import { render } from "./Logo.vue?vue&type=template&id=21534ac9"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=21534ac9&rel=stylesheet&lang=scss"
script.render = render

export default script